/** Member (private app) JWT */
export const MEMBER_TOKEN_KEY = "token";
/** Guest enrollment flow JWT — never treated as a private-route session */
export const GUEST_TOKEN_KEY = "guestToken";
/** Guest campaign / profile payload stored during open enrollment */
export const GUEST_LOGIN_RESPONSE_KEY = "guestLoginResponse";

export function clearGuestSessionStorage() {
  localStorage.removeItem(GUEST_LOGIN_RESPONSE_KEY);
  localStorage.removeItem(GUEST_TOKEN_KEY);
}

export function hasMemberSession() {
  return !!localStorage.getItem(MEMBER_TOKEN_KEY);
}

export function hasGuestSession() {
  return !!localStorage.getItem(GUEST_TOKEN_KEY);
}

/** Authorization: member token wins if both are present */
export function getBearerToken() {
  const member = localStorage.getItem(MEMBER_TOKEN_KEY);
  if (member) return `Bearer ${member}`;
  const guest = localStorage.getItem(GUEST_TOKEN_KEY);
  if (guest) return `Bearer ${guest}`;
  return undefined;
}
